import { LocalStorageKeys } from "@is/constants";
import { LocalStorageService } from "@is/services";

export const getLanguageFromLocalStorage = () =>
  LocalStorageService.getItem(LocalStorageKeys.LanguageCode)?.split("-")[0];
